import { Dispatch } from 'react';
import clsx from 'clsx';

interface SlideAddType {
  text: string;
  className?: string;
  style?: { width: string | number; height: string | number };
  onClick: Dispatch<React.SetStateAction<boolean>>;
}

export const SlideAdd = (props: SlideAddType) => {
  const handleOpenModal = () => {
    props.onClick(true);
  };

  return (
    <div style={props.style} className={clsx(props.className, props.text === 'Add card' ? 'aspect-[5/3]' : '')} onClick={handleOpenModal}>
      <div
        className={clsx(
          'h-full w-full rounded border-2 border-[#585858] bg-gradient-to-b from-[#282828] to-[#212121] transition-all duration-100 ease-linear hover:rounded hover:border-0 hover:border-transparent hover:shadow-[12px_12px_24px_0_rgba(0,0,0,0.23)]',
          props.text === 'Add card' ? '!rounded-2xl' : '',
        )}
      >
        <div className='flex h-[inherit] flex-col items-center justify-center'>
          <div>
            <svg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'>
              <path d='M28 15h-13v13h-2v-13h-13v-2h13v-13h2v13h13z' fill='#585858' />
            </svg>
          </div>
          <div className='mt-2.5 text-sm text-[#585858] uppercase'>{props.text}</div>
        </div>
      </div>
    </div>
  );
};
